import React from 'react';
import { Link } from 'react-router-dom';
import { GAME_INFO } from '../../services/playHistory';
import './PlayHistory.css';

const clock = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;

const when = (t) => {
  const d = new Date(t);
  const days = Math.floor((new Date(new Date().toDateString()) - new Date(d.toDateString())) / 86400000);
  if (days === 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days} days ago`;
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
};

const PlayHistory = ({ plays, limit, emptyText = 'No games yet. Finish one and it shows up here.' }) => {
  const shown = limit ? plays.slice(0, limit) : plays;
  if (!shown.length) {
    return (
      <div className="ph-empty">
        <p>{emptyText}</p>
        <Link to="/" className="ph-empty-link">Pick a game</Link>
      </div>
    );
  }
  return (
    <ul className="ph-list">
      {shown.map((p, i) => {
        const g = GAME_INFO[p.gameType] || { name: p.gameType, path: '/' };
        const img = p.image || g.icon;
        return (
          <li key={`${p.gameType}-${p.at}-${i}`}>
            <Link to={g.path} className="ph-row">
              {img ? (
                <img src={img} alt="" className="ph-img" />
              ) : (
                <span className="ph-img ph-emoji" aria-hidden="true">{g.emoji}</span>
              )}
              <span className="ph-main">
                <span className="ph-game">{g.name}</span>
                <span className="ph-detail">
                  {p.result || (p.score !== undefined && g.outOf ? `${p.score}/${g.outOf}` : '')}
                  {p.record ? <span className="ph-star" title="Best time"> ★</span> : null}
                </span>
              </span>
              <span className="ph-side">
                {p.totalTime ? <span className="ph-time">{clock(p.totalTime)}</span> : null}
                <span className="ph-when">{when(p.at)}</span>
              </span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default PlayHistory;
